import React, { FC } from 'react';
import { Box } from '@mui/material';
import AddRUT from '../components/LoginScreenComponents/AddRUT';

const PatchRUT: FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <AddRUT />
        </Box>
      </Box>
    </Box>
  );
};

export default PatchRUT;
